export interface RelatedViews {
  isCollapsed: boolean;
};

export const DEFAULT_RELATED_VIEWS: RelatedViews = {
  isCollapsed: undefined
};




// WEBPACK FOOTER //
// ./src/models/related-views.ts